import { render, staticRenderFns } from "./folder-item-view-2-graph-view.vue?vue&type=template&id=1dd59a5a&"
import script from "./folder-item-view-2-graph-view.vue?vue&type=script&lang=ts&"
export * from "./folder-item-view-2-graph-view.vue?vue&type=script&lang=ts&"
import style0 from "./folder-item-view-2-graph-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon,VTextField})
